module.exports = __webpack_public_path__ + "media/images/version_merge/fdf/img-50f704a35805b09deba258838a9da517.svg";